module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-120x120-1e46d77b6a2fa93c615a671c9224db56.png";